import PropTypes from 'prop-types';
import EditableTitle from './EditableTitle';
import {Form, Header, Segment} from 'semantic-ui-react';
import ComparableMap from './ComparableMap';

export default function CustomiseComparableMap({
  reportType,
  section,
  targetLatLng,
  center,
  zoom,
  markers,
  updateSectionValue,
  updatePreferences,
  onMapCenterChange,
  onMapZoomChange,
}) {
  return (
    <div className="comparable-map">
      <Header as="h2" className="section-type" style={{fontWeight: 'bold'}} disabled>Comparables Map</Header>
      <Segment style={{padding: '30px'}}>
        <Header as="h3" disabled>Title</Header>
        <Form className="sectionData">
          <Form.Group inline>
            <EditableTitle
              onUpdateData={(data) => {
                updateSectionValue(data.title, 'title');
                updatePreferences({'comparableMap.sectionData.title': data.title}, reportType);
              }}
              isEnabled={true}
              maxLength={32}
              width="50%"
              title={section.sectionData.title}/>
          </Form.Group>
        </Form>
        <div>
          <ComparableMap targetLatLng={targetLatLng}
                         center={center}
                         zoom={zoom}
                         markers={markers}
                         onMapCenterChange={onMapCenterChange}
                         onMapZoomChange={onMapZoomChange}
          />
        </div>
      </Segment>
    </div>
  );
}

CustomiseComparableMap.propTypes = {
  markers: PropTypes.array,
  reportType: PropTypes.string.isRequired,
  section: PropTypes.shape({
    sectionData: PropTypes.shape({
      title: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  targetLatLng: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }),
  center: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }),
  zoom: PropTypes.number,
  updateSectionValue: PropTypes.func.isRequired,
  updatePreferences: PropTypes.func.isRequired,
  onMapCenterChange: PropTypes.func.isRequired,
  onMapZoomChange: PropTypes.func.isRequired,
};
